<!--School Selector-->
<div style="padding: 20px 20px 0px 20px; background-color: #ebebeb">
	<caass-schoolselector [ShowAll]="false"> </caass-schoolselector>
</div>

<!--Lockers-->
<div>
	<caass-locker-table [School]="School" (SelectedLockerChanged)="onSelectedLockerChanged($event)"> </caass-locker-table>
</div>

<!--History for selected Locker-->
<div>
	<caass-locker-history-table [SelectedLocker]="SelectedLocker" (UpdateParent)="onUpdateParent($event)"> </caass-locker-history-table>
</div>
